import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import * as DevExtreme from 'devextreme/dist/js/dx.all';
import { BillOfMaterialService } from 'pages/quote-setup/bill-of-material/service';
import { PartService } from 'pages/quote-setup/parts/service';
import { DialogService } from 'aurelia-dialog';
import toastr from 'toastr';

@inject(BillOfMaterialService, PartService, DialogService, EventAggregator)
export class BillOfMaterialItem {
    constructor(billOfMaterialService, partService, dialogService, ea) {
        this.billOfMaterialService = billOfMaterialService;
        this.partService = partService;
        this.dialogService = dialogService;
        this.ea = ea;

        this.columns = [
            { dataField: 'number' },
            { dataField: 'quantity' },
            { dataField: 'type' },
            { dataField: 'location', caption: 'Purchase Type / Mfg Location' },
            { caption: 'Actions', cellTemplate: (container, options) => {
                const div = document.createElement('div');
                const btn1 = document.createElement('a');
                btn1.addEventListener('click', (e) => { e.preventDefault(); this.add(options.data.partId); });
                btn1.href = '#';
                btn1.innerText = 'Add';

                const btn2 = document.createElement('a');
                btn2.addEventListener('click', (e) => { e.preventDefault(); this.edit(options.data); });
                btn2.href = '#';
                btn2.innerText = 'Edit';
                btn2.style.marginLeft = '10px';

                const btn3 = document.createElement('a');
                btn3.addEventListener('click', (e) => { e.preventDefault(); this.delete(options.data); });
                btn3.href = '#';
                btn3.innerText = 'Delete';
                btn3.style.marginLeft = '10px';

                div.append(btn1);
                div.append(btn2);
                div.append(btn3);
                container.append(div);
            }, allowExporting: false }
        ];
    }

    async activate(params) {
        this.part = await this.partService.getById(params.id);
        await this.loadParts();
    }

    async loadParts() {
        this.children = await this.billOfMaterialService.getChildren(this.part.id);
        const instance = $(this.treeList).dxTreeList('instance');
        if (instance) {
            $(this.treeList).dxTreeList('option', 'dataSource', this.children);
            instance.refresh();
        }
    }

    attached() {
        this.buildTreeList();
    }

    add = (partId) => {
        this.dialogService.open({ viewModel: this.billOfMaterialService.editor, model: { parentPartId: partId } }).whenClosed(async (response) => {
            this.ea.publish(`bom-part-${partId}`);
            if (!response.wasCancelled) {
                await this.loadParts();
            }
        });
    };

    edit = (bom) => {
        this.dialogService.open({ viewModel: this.billOfMaterialService.editor, model: { id: bom.id, parentPartId: bom.parentPartId } }).whenClosed(async (response) => {
            this.ea.publish(`bom-part-${bom.parentPartId}`);
            if (!response.wasCancelled) {
                await this.loadParts();
            }
        });
    };

    delete = (bom) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.billOfMaterialService.delete(bom.parentPartId, bom.id);
                this.ea.publish(`bom-part-${bom.parentPartId}`);
                await this.loadParts();
                toastr.success('Child part was deleted!');
            }
        });
    };

    buildTreeList() {
        $(this.treeList).dxTreeList({
            columns: this.columns,
            dataSource: this.children,
            dataStructure: 'tree',
            itemsExpr: 'childParts'
        });
    }

    generateMasterDetail() {
        return {
            enabled: true,
            autoExpandAll: true,
            template: (container, options) => {
                const button = $('<button type="button" class="btn btn-primary">')
                button.text('Add');
                button.click((e) => {
                    this.add(options.data.partId);
                });

                $('<div>')
                    .append(button)
                    .appendTo(container);
                    

                $('<div>').dxDataGrid({
                    columnAutoWidth: true,
                    showBorders: true,
                    allowColumnReordering: false,
                    columns: [
                        { dataField: 'number' },
                        { dataField: 'quantity' },
                        { dataField: 'type' },
                        { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
                    ],
                    dataSource: options.data.childParts,
                    masterDetail: this.generateMasterDetail()
                }).appendTo(container);
            }
        };
    }
}